import { c as _c } from "react/compiler-runtime";
import { useCallback, useMemo } from 'react';
import { WhatYouWillLearn } from '@/features/course-landing-page/components/what-you-will-learn/what-you-will-learn.react-component';
import { RelatedTopics } from '@/features/course-landing-page/components/related-topics/related-topics.react-component';
import { Description } from '@/features/course-landing-page/components/course-description/course-description.react-component';
import { CourseIncludes, CourseIncludesPlacement } from '../course-includes/course-includes.react-component';
import { Requirements } from '@/features/course-landing-page/components/course-requirements/course-requirements.react-component';
import { useClpPurchaseContext } from '@/features/course-landing-page/context/clp-purchase-context.react-component';
import { Curriculum } from '@/features/course-landing-page/components/course-curriculum/curriculum.react-component';
import { CodingExercisePromotion } from '@/features/course-landing-page/components/coding-exercise-promotion/coding-exercise-promotion.react-component';
import { InstructorList } from '@/features/course-landing-page/components/instructor-module/instructor-list/instructor-list.react-component';
import { ReviewsContainer } from '@/features/course-landing-page/components/reviews/reviews-container.react-component';
import { useClpCourse } from '@/features/course-landing-page/context/clp-course-provider.react-component';
import { useCourseCareerAccelerator } from '@/features/course-landing-page/context/career-accelerator-provider.react-component';
import { MoreCoursesByInstructors } from '@/features/course-landing-page/components/more-courses-by-instructors/more-courses-by-instructors.react-component';
import { FrequentlyBoughtTogetherWithBundleUnit } from '@/features/course-landing-page/components/bundle-unit/frequently-bought-together/frequently-bought-together.react-component';
import { StudentsAlsoBoughtRecommendationsWrapper } from '../students-also-bought/students-also-bought-recommendations-wrapper.react-component';
import { CertificationExamVoucherBanner, CertificationVoucherBundleUnit, CourseCertificationUnit, GoogleCareerAcceleratorData, GoogleCareerCourseCarousel, IncentiveTextType, useVoucherBannerData } from '@udemy-v2/react-certification-preparation';
import { publishEvent, TrackImpression } from '@udemy-v2/event-tracking';
import { ExperimentImpressionEvent, useFeatures } from '@udemy-v2/react-experimentation';
import { GrowWithGoogleCertificateBanner } from '@udemy-v2/react-subscription-browse';
import { useMatchMedia } from '@udemy-v2/design-system-utils';
import { useCommonData } from '@udemy-v2/common-data';
import { CertificationBundle } from '../bundle-unit/certification-bundle/certification-bundle.react-component';
import { tokens } from '@udemy-v2/styles';
import styles from './course-body-content.module.scss';
import { ReportAbuse } from '../report-abuse/report-abuse.react-component';
import { LocalizedHtml, useI18n } from '@udemy-v2/i18n';
import { getGoogleCareerPathUrl } from '@/features/course-landing-page/utils/google';
import { useClpVoucherContext } from '@/features/course-landing-page/context/voucher-context.react-component';
import { CourseSubscriptionAvailabilityStatus, useCoursesSubscriptionAvailabilityQuery } from '@/generated/graphql';
import { BUNDLE_COUPON } from '@/features/course-landing-page/constants';
import { CourseRetirementBanner } from '../course-retirement-banner/course-retirement-banner.react-component';
export const CourseBodyContent = () => {
  const $ = _c(107);
  const commonData = useCommonData();
  const {
    gettext,
    interpolate
  } = useI18n();
  const hasOrganization = !!commonData?.organization;
  const isMobile = useMatchMedia(`(max-width: ${tokens["viewport-sm-max"]})`);
  const course = useClpCourse();
  const {
    isLoading,
    isCourseInAvailablePlans,
    isPersonalPlanSubscriber,
    useCollapsiblePurchaseSection
  } = useClpPurchaseContext();
  const courseCareerAccelerator = useCourseCareerAccelerator();
  const isMarketplace = !isPersonalPlanSubscriber && !hasOrganization;
  const courseIncludedInAvailableSubscription = !isLoading && isCourseInAvailablePlans;
  const renderIncentivesInCourseBody = isMobile || !isMobile && courseIncludedInAvailableSubscription || useCollapsiblePurchaseSection;
  const {
    hydratedCertificationBundle,
    isLoading: isLoadingVoucherContext
  } = useClpVoucherContext();
  let t0;
  if ($[0] !== hydratedCertificationBundle?.contents) {
    t0 = hydratedCertificationBundle?.contents.map(_temp) ?? [];
    $[0] = hydratedCertificationBundle?.contents;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const courseIds = t0;
  const hasCertBundle = !!hydratedCertificationBundle && courseIds.length > 0;
  const courseIncludesCodingExercise = course.curriculum?.contentCounts?.codingExercisesCount && course.curriculum.contentCounts.codingExercisesCount > 0;
  const showUpdatedCertificationUnit = !hasOrganization;
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["show_exam_voucher_banner_in_clp", "show_certification_voucher_bundle_unit"];
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const {
    isLoading: isFeaturesLoading,
    featureVariantAssignments
  } = useFeatures(t1);
  const isGrowWithGoogleCourse = !!course.contentCollectionInfo?.isInGooglePartnerCollection;
  let t2;
  if ($[3] !== featureVariantAssignments) {
    t2 = featureVariantAssignments.get("show_exam_voucher_banner_in_clp");
    $[3] = featureVariantAssignments;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const examVoucherFeatureAssignment = t2;
  const showExamVoucherBannerInCLP = examVoucherFeatureAssignment?.configuration?.showExamVoucherBannerInCLP;
  let t3;
  if ($[5] !== featureVariantAssignments) {
    t3 = featureVariantAssignments.get("show_certification_voucher_bundle_unit");
    $[5] = featureVariantAssignments;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const certificationVoucherBundleUnitFeature = t3;
  const showCertificationVoucherBundleUnit = certificationVoucherBundleUnitFeature?.configuration?.showCertificationVoucherBundleUnit;
  let t4;
  if ($[7] !== courseIds) {
    t4 = {
      ids: courseIds
    };
    $[7] = courseIds;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== hasCertBundle) {
    t5 = {
      enabled: hasCertBundle
    };
    $[9] = hasCertBundle;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const {
    data: bundleSubscriptionData,
    isLoading: isBundleSubscriptionLoading
  } = useCoursesSubscriptionAvailabilityQuery(t4, t5);
  let t6;
  if ($[11] !== bundleSubscriptionData?.courses || $[12] !== isBundleSubscriptionLoading) {
    t6 = !isBundleSubscriptionLoading && (bundleSubscriptionData?.courses ?? []).every(_temp2);
    $[11] = bundleSubscriptionData?.courses;
    $[12] = isBundleSubscriptionLoading;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  const allCoursesExcludedFromSubscription = t6;
  const canRenderCertificationVoucherBundleUnit = showCertificationVoucherBundleUnit && !!hydratedCertificationBundle && allCoursesExcludedFromSubscription;
  let voucherTopicIds;
  if ($[14] !== course.primaryTopic || $[15] !== course.topics) {
    voucherTopicIds = [];
    if (course?.primaryTopic?.id != null) {
      voucherTopicIds.push(String(course.primaryTopic.id));
    }
    course?.topics?.forEach(topic => {
      const id = String(topic.id);
      if (!voucherTopicIds.includes(id)) {
        voucherTopicIds.push(id);
      }
    });
    $[14] = course.primaryTopic;
    $[15] = course.topics;
    $[16] = voucherTopicIds;
  } else {
    voucherTopicIds = $[16];
  }
  const {
    canRender: canRenderVoucherBanner,
    bannerData
  } = useVoucherBannerData(voucherTopicIds);
  const isEligibleForExamVoucherBanner = !isFeaturesLoading && canRenderVoucherBanner && !!bannerData && !!examVoucherFeatureAssignment;
  const canRenderExamVoucherBanner = isEligibleForExamVoucherBanner && !!showExamVoucherBannerInCLP;
  let t7;
  if ($[17] !== examVoucherFeatureAssignment?.experimentIds) {
    t7 = () => {
      publishEvent(new ExperimentImpressionEvent({
        experimentIds: examVoucherFeatureAssignment?.experimentIds ?? [],
        isLocalDefaultShown: false
      }));
    };
    $[17] = examVoucherFeatureAssignment?.experimentIds;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  const handleExperimentImpression = t7;
  let t8;
  if ($[19] !== course.id) {
    t8 = {
      contextId: "clp-bundle" as const,
      sourceObjects: [{
        id: course.id,
        type: "COURSE" as never
      }]
    };
    $[19] = course.id;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  const bundleContextInput = t8;
  const pathName = courseCareerAccelerator?.career?.name ?? "";
  let t9;
  if ($[21] !== courseCareerAccelerator || $[22] !== gettext || $[23] !== interpolate || $[24] !== pathName) {
    t9 = courseCareerAccelerator ? <LocalizedHtml html={interpolate(gettext("After completion of all courses in the <a class=\"certificate\">%(certificateName)s</a> path, earn a professional certificate that you can share on social media, LinkedIn, resume, or CV. "), {
      certificateName: pathName
    }, true)} interpolate={{
      certificate: <a href={getGoogleCareerPathUrl(courseCareerAccelerator.slug)}>{pathName}</a>
    }} /> : null;
    $[21] = courseCareerAccelerator;
    $[22] = gettext;
    $[23] = interpolate;
    $[24] = pathName;
    $[25] = t9;
  } else {
    t9 = $[25];
  }
  const certificateBannerDescription = t9;
  let t10;
  if ($[26] !== hasOrganization) {
    t10 = hasOrganization && <CourseRetirementBanner />;
    $[26] = hasOrganization;
    $[27] = t10;
  } else {
    t10 = $[27];
  }
  let t11;
  if ($[28] !== certificateBannerDescription || $[29] !== courseCareerAccelerator || $[30] !== gettext) {
    t11 = courseCareerAccelerator && courseCareerAccelerator.certificateInfo?.certificateImageUrl && <GrowWithGoogleCertificateBanner iconButtonProps={{
      href: getGoogleCareerPathUrl(courseCareerAccelerator.slug)
    }} description={certificateBannerDescription} title={gettext("Earn a certificate from Google")} />;
    $[28] = certificateBannerDescription;
    $[29] = courseCareerAccelerator;
    $[30] = gettext;
    $[31] = t11;
  } else {
    t11 = $[31];
  }
  const t12 = Number(course.id);
  let t13;
  if ($[32] !== isMarketplace || $[33] !== isMobile || $[34] !== showUpdatedCertificationUnit || $[35] !== t12) {
    t13 = <CourseCertificationUnit courseId={t12} linkToTopic={isMarketplace} showLearnMoreModal={isMarketplace} isMobile={isMobile} showAddToInterestButton={showUpdatedCertificationUnit} showIncentiveTextType={IncentiveTextType.PUBLIC} />;
    $[32] = isMarketplace;
    $[33] = isMobile;
    $[34] = showUpdatedCertificationUnit;
    $[35] = t12;
    $[36] = t13;
  } else {
    t13 = $[36];
  }
  let t14;
  if ($[37] !== course.learningOutcomes) {
    t14 = <WhatYouWillLearn objectives={course.learningOutcomes} />;
    $[37] = course.learningOutcomes;
    $[38] = t14;
  } else {
    t14 = $[38];
  }
  let t15;
  if ($[39] !== course) {
    t15 = <RelatedTopics course={course} />;
    $[39] = course;
    $[40] = t15;
  } else {
    t15 = $[40];
  }
  let t16;
  if ($[41] !== renderIncentivesInCourseBody) {
    t16 = renderIncentivesInCourseBody && <CourseIncludes placement={CourseIncludesPlacement.BODY} />;
    $[41] = renderIncentivesInCourseBody;
    $[42] = t16;
  } else {
    t16 = $[42];
  }
  let t17;
  if ($[43] !== course.frontendTrackingId || $[44] !== course.id || $[45] !== courseIncludesCodingExercise) {
    t17 = !!courseIncludesCodingExercise && <CodingExercisePromotion courseId={Number(course.id)} frontendTrackingId={course.frontendTrackingId || ""} />;
    $[43] = course.frontendTrackingId;
    $[44] = course.id;
    $[45] = courseIncludesCodingExercise;
    $[46] = t17;
  } else {
    t17 = $[46];
  }
  let t18;
  if ($[47] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <Curriculum />;
    $[47] = t18;
  } else {
    t18 = $[47];
  }
  let t19;
  if ($[48] !== course.isPracticeTestCourse || $[49] !== course.prerequisites) {
    t19 = !course.isPracticeTestCourse && <Requirements prerequisites={course.prerequisites} />;
    $[48] = course.isPracticeTestCourse;
    $[49] = course.prerequisites;
    $[50] = t19;
  } else {
    t19 = $[50];
  }
  let t20;
  if ($[51] !== course.description || $[52] !== course.targetAudience) {
    t20 = <Description description={course.description} targetAudience={course.targetAudience} />;
    $[51] = course.description;
    $[52] = course.targetAudience;
    $[53] = t20;
  } else {
    t20 = $[53];
  }
  let t21;
  if ($[54] !== courseCareerAccelerator || $[55] !== gettext || $[56] !== isGrowWithGoogleCourse) {
    t21 = isGrowWithGoogleCourse && courseCareerAccelerator && <GoogleCareerCourseCarousel ariaLabel={gettext("Google Career Certificate courses")} acceleratorData={[courseCareerAccelerator] as GoogleCareerAcceleratorData[]} ctaHref={getGoogleCareerPathUrl(courseCareerAccelerator.slug)} />;
    $[54] = courseCareerAccelerator;
    $[55] = gettext;
    $[56] = isGrowWithGoogleCourse;
    $[57] = t21;
  } else {
    t21 = $[57];
  }
  let t22;
  if ($[58] !== certificationVoucherBundleUnitFeature || $[59] !== hydratedCertificationBundle || $[60] !== isFeaturesLoading) {
    t22 = !isFeaturesLoading && hydratedCertificationBundle && <TrackImpression trackFunc={() => {
      if (certificationVoucherBundleUnitFeature) {
        const {
          experimentIds: t23,
          isLocalDefault: t24
        } = certificationVoucherBundleUnitFeature;
        const experimentIds = t23 === undefined ? [] : t23;
        const isLocalDefault = t24 === undefined ? false : t24;
        publishEvent(new ExperimentImpressionEvent({
          experimentIds,
          isLocalDefaultShown: isLocalDefault
        }));
      }
    }} onlyOnce={true}><div /></TrackImpression>;
    $[58] = certificationVoucherBundleUnitFeature;
    $[59] = hydratedCertificationBundle;
    $[60] = isFeaturesLoading;
    $[61] = t22;
  } else {
    t22 = $[61];
  }
  let t23;
  if ($[62] !== canRenderCertificationVoucherBundleUnit || $[63] !== hydratedCertificationBundle || $[64] !== isFeaturesLoading) {
    t23 = !isFeaturesLoading && canRenderCertificationVoucherBundleUnit && hydratedCertificationBundle ? <CertificationVoucherBundleUnit layout="vertical" bundle={hydratedCertificationBundle} isVoucherBundleDiscountEnabled={true} bundleCouponCode={BUNDLE_COUPON} /> : null;
    $[62] = canRenderCertificationVoucherBundleUnit;
    $[63] = hydratedCertificationBundle;
    $[64] = isFeaturesLoading;
    $[65] = t23;
  } else {
    t23 = $[65];
  }
  let t24;
  if ($[66] !== bannerData || $[67] !== canRenderExamVoucherBanner || $[68] !== handleExperimentImpression || $[69] !== isEligibleForExamVoucherBanner) {
    t24 = isEligibleForExamVoucherBanner && <TrackImpression trackFunc={handleExperimentImpression} onlyOnce={true}>{canRenderExamVoucherBanner ? <CertificationExamVoucherBanner bannerData={bannerData} colorScheme="dark" /> : <div />}</TrackImpression>;
    $[66] = bannerData;
    $[67] = canRenderExamVoucherBanner;
    $[68] = handleExperimentImpression;
    $[69] = isEligibleForExamVoucherBanner;
    $[70] = t24;
  } else {
    t24 = $[70];
  }
  let t25;
  if ($[71] === Symbol.for("react.memo_cache_sentinel")) {
    t25 = <StudentsAlsoBoughtRecommendationsWrapper />;
    $[71] = t25;
  } else {
    t25 = $[71];
  }
  let t26;
  if ($[72] !== bundleContextInput || $[73] !== canRenderCertificationVoucherBundleUnit || $[74] !== courseIds || $[75] !== hasCertBundle || $[76] !== hasOrganization || $[77] !== isFeaturesLoading || $[78] !== isLoadingVoucherContext) {
    t26 = !isFeaturesLoading && !isLoadingVoucherContext ? <div className={styles["bundle-unit-container"]}>{canRenderCertificationVoucherBundleUnit ? null : hasCertBundle ? <CertificationBundle bundleCourseIds={courseIds} /> : hasOrganization ? null : <FrequentlyBoughtTogetherWithBundleUnit contextInput={bundleContextInput} />}</div> : null;
    $[72] = bundleContextInput;
    $[73] = canRenderCertificationVoucherBundleUnit;
    $[74] = courseIds;
    $[75] = hasCertBundle;
    $[76] = hasOrganization;
    $[77] = isFeaturesLoading;
    $[78] = isLoadingVoucherContext;
    $[79] = t26;
  } else {
    t26 = $[79];
  }
  let t27;
  if ($[80] === Symbol.for("react.memo_cache_sentinel")) {
    t27 = <InstructorList />;
    $[80] = t27;
  } else {
    t27 = $[80];
  }
  const t28 = parseInt(course.id, 10);
  let t29;
  if ($[81] !== t28) {
    t29 = <ReviewsContainer courseId={t28} />;
    $[81] = t28;
    $[82] = t29;
  } else {
    t29 = $[82];
  }
  let t30;
  if ($[83] !== course.instructors || $[84] !== hasOrganization) {
    t30 = !hasOrganization && <MoreCoursesByInstructors instructors={course.instructors} />;
    $[83] = course.instructors;
    $[84] = hasOrganization;
    $[85] = t30;
  } else {
    t30 = $[85];
  }
  let t31;
  if ($[86] !== course.id || $[87] !== hasOrganization) {
    t31 = !hasOrganization && <ReportAbuse objectId={Number(course.id)} objectType="course" fullWidthButton={true} udStyle="secondary" withDivider={true} />;
    $[86] = course.id;
    $[87] = hasOrganization;
    $[88] = t31;
  } else {
    t31 = $[88];
  }
  let t32;
  if ($[89] !== t10 || $[90] !== t11 || $[91] !== t13 || $[92] !== t14 || $[93] !== t15 || $[94] !== t16 || $[95] !== t17 || $[96] !== t19 || $[97] !== t20 || $[98] !== t21 || $[99] !== t22 || $[100] !== t23 || $[101] !== t24 || $[102] !== t26 || $[103] !== t29 || $[104] !== t30 || $[105] !== t31) {
    t32 = <div className={styles.container}>{t10}{t11}{t13}{t14}{t15}{t16}{t17}{t18}{t19}{t20}{t21}{t22}{t23}{t24}{t25}{t26}{t27}{t29}{t30}{t31}</div>;
    $[89] = t10;
    $[90] = t11;
    $[91] = t13;
    $[92] = t14;
    $[93] = t15;
    $[94] = t16;
    $[95] = t17;
    $[96] = t19;
    $[97] = t20;
    $[98] = t21;
    $[99] = t22;
    $[100] = t23;
    $[101] = t24;
    $[102] = t26;
    $[103] = t29;
    $[104] = t30;
    $[105] = t31;
    $[106] = t32;
  } else {
    t32 = $[106];
  }
  return t32;
};
function _temp(c) {
  return String(c.id);
}
function _temp2(course_0) {
  return course_0?.subscriptionInfo?.availabilityStatus === CourseSubscriptionAvailabilityStatus.None;
}